import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { isMobileDevice } from 'lib/utils';
import SimpleAddToBasket from '../products/simple_add_to_basket';

const StickyAddToBasket = ({
  productId,
  deliveryStock,
  gtmTitle,
  brand,
  stock_code: stockCode,
  category,
  productStepId,
  description,
  prodMinOrder,
  prodDeliveryMinOrder,
  prodMaxQuant,
  vatExclusive,
}) => {
  const [addingToBasket, setAddingToBasket] = useState(false);
  const [show, setShow] = useState(false);
  const [productPrice, setProductPrice] = useState();

  const isVisible = el => {
    const rect = el.getBoundingClientRect();
    const elemTop = rect.top;
    const elemBottom = rect.bottom;

    // Partially visible elements return true:
    const isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
  };

  const isAddingToBasket = () => {
    setAddingToBasket(currentVal => !currentVal);
  };

  const getPrice = () => {
    axios(`/product_price?products=${productId}`, {
      method: 'GET',
      dataType: 'json',
      headers: {
        'Content-Type': 'text/javascript',
        Accept: 'text/javascript',
      },
    })
      .then(({ data }) => {
        setProductPrice(data[productId]);
      })
      .catch(() => {});
  };

  const handleUnit = unit => {
    let value;

    switch (unit) {
      case 'm':
      case 'kg':
        value = unit;
        break;
      case 'each':
      case 'Each':
        value = '';
        break;
      default:
        value = ` ${unit}`;
    }

    return value;
  };

  const handleTracking = () => {
    if (window.dataLayer && productPrice) {
      window.dataLayer.push({
        event: 'addBasket',
        ecommerce: {
          currencyCode: 'GBP',
          add: {
            products: [
              {
                id: stockCode,
                'id-variant': productStepId,
                name: gtmTitle,
                price: productPrice.price,
                brand: brand || '',
                category,
                quantity: 1,
              },
            ],
          },
        },
      });
    }
  };

  useEffect(() => {
    getPrice();
    window.addEventListener('scroll', function () {
      const basketButton = document.querySelector('#Delivery');
      const header = document.querySelector('.cef-site-header');
      const footer = document.querySelector('.site-footer');
      const productImage = document.querySelector('.product-image__wrapper');

      if (
        (isMobileDevice() &&
          !isVisible(basketButton) &&
          !isVisible(header) &&
          !isVisible(footer) &&
          !isVisible(productImage)) ||
        (!isMobileDevice() && !isVisible(basketButton) && !isVisible(header))
      ) {
        setShow(true);
      } else {
        setShow(false);
      }
    });
  }, []);
  if (!productPrice) {
    return null;
  }

  return (
    <div
      className={show ? 'sticky-header sticky-header--show' : 'sticky-header'}>
      <div className="container">
        <div className="fl ai-c jc-sb">
          <p className="sticky-header__title">
            {brand !== null ? brand + ' ' : ''}
            {description}
          </p>
          <div className="fl ai-c fl-grow-1 jc-sb sticky-header-content">
            <div className="fl fl-col sticky-header-price-wrapper">
              <p className="sticky-header__price">
                £
                {vatExclusive === true
                  ? productPrice.price.toFixed(2)
                  : productPrice.price_inclusive.toFixed(2)}
                <span className="sticky-header__quantity">
                  For {productPrice.quantity}
                </span>
                <span className="sticky-header__uom">
                  {handleUnit(productPrice.unit)}
                </span>
              </p>

              <p className="sticky-header__price-vat">
                £
                {vatExclusive === true
                  ? productPrice.price_inclusive.toFixed(2) + ' inc VAT'
                  : productPrice.price.toFixed(2) + ' ex VAT'}
              </p>
            </div>

            <SimpleAddToBasket
              productStepId={productStepId}
              prodMinOrder={prodMinOrder}
              prodDeliveryMinOrder={prodDeliveryMinOrder}
              prodMaxQuant={prodMaxQuant}
              addValue="Add to Basket"
              url="/basket"
              isAddingToBasket={isAddingToBasket}
              addingToBasket={addingToBasket}
              handleTracking={handleTracking}
              stockLevel={deliveryStock}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyAddToBasket;
